<template>
  <div>
    <router-link to="/plan/tools" class="back-link">
      <Flexy><img :src="ArrowRightIcon" /> <p>{{t('Info Slides')}}</p></Flexy>
    </router-link>
    <div class="boxes light">
<!--      <Box :title="t('Lifesavers')" link="/plan/tools/lifesavers" />-->
<!--      <div v-for="(slide, index) in validTips" :key="index" class="slide">-->
<!--        <img :src="slide" alt="slide" @click="selectedSlide = slide" />-->
<!--      </div>-->
      <Box v-for="(slide, index) in validTips" :key="index" :title="slide.title" :callback="() => selectedSlide = slide" />

      <div class="slide-overlay" v-if="selectedSlide">
        <div class="slide-overlay-inner">
          <img class="slide-img" :src="selectedSlide.slide" alt="slide" />
          <div class="slide-overlay-close" @click="selectedSlide = null">
            <img :src="CloseIcon" style="width: 16px; height: 16px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import t from '@/lib/Locale';
import CloseIcon from "@/assets/icons/x.svg"
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';

import Fito from "@/lib/fito";
import Flexy from "@/components/ui/widgets/Flexy.vue";
import Box from "@/components/ui/widgets/Box.vue";

export default {
  name: "InfoSlides",
  components: {Box, Flexy},
  data() {
    return {
      CloseIcon, ArrowRightIcon,
      loadedItems : [],
      selectedSlide: null,
      daysInPlan: -1,
    }
  },
  async mounted() {
    const login = await Fito().Login.safeCheckLogin();
    if (!login) await this.$router.push('/plan/login');

    this.daysInPlan = login.daysInPlan
    this.loadData()
  },
  computed: {
    validTips() {
      let slides = []
      for (let i = 0; i < this.loadedItems.length; i++) {
        if (this.loadedItems[i].day <= this.daysInPlan) {
          console.log(this.loadedItems[i])
          slides.push(this.loadedItems[i])
        }
      }
      return slides
    }
  },
  methods: {
    t,
    async loadData() {
      const sheet = await Fito().loadSheet('info-slides');
      for (let item of sheet) {
        this.loadedItems.push({day: item[2]*1, slide: item[0], title: item[1]})
      }
      console.log(this.loadedItems)
    }
  }
}
</script>
